/*
 * @Author: fredwei
 * @Date: 2019-06-03 10:42:53
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2020-03-24 17:09:18
 */

export function isvalidUsername(str) {
  return ['admin', 'editor'].indexOf(str.trim()) >= 0;
}

/* 合法uri */
export function validateURL(textval) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(textval);
}

/* 小写字母 */
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母 */
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母 */
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

// 校验用户名
export function validateUsername(rule, value, callback) {
  const reg = /^[A-Za-z0-9]{6,20}$/;
  // const reg = /^[A-Za-z0-9]{4,20}$/;

  if (!value) {
    callback(new Error('用户名/手机号不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('请输入6-20位字符，仅支持字母、数字'));
  } else {
    callback();
  }
}

// 校验密码
export function validatePassword(rule, value, callback) {
  // const reg = /^[A-Za-z0-9]{6,12}$/;
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;

  if (!value) {
    callback(new Error('密码不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('请输入6-12位数字与字母组合'));
  } else {
    callback();
  }
}

// 校验手机
export function validatePhone(rule, value, callback) {
  // const reg = /^[0-9]{11}$/;
  const reg = /^1[23456789]\d{9}$/;

  console.log(rule);

  if (!value) {
    callback(new Error('手机号码不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('请输入正确的11位电话号码'));
  } else {
    callback();
  }
}

// 校验手机-可为空
export function validatePhone2(rule, value, callback) {
  // const reg = /^[0-9]{11}$/;
  const reg = /^1[23456789]\d{9}$/;

  if (value && !reg.test(value)) {
    callback(new Error('请输入正确的11位电话号码'));
  } else {
    callback();
  }
}

// 校验电话，支持座机和手机
export function validateTelephone(rule, value, callback) {
  const reg1 = /^(\(\d{3,4}\)|（\d{3,4}\）|\d{3,4}-|\s)?\d{6,9}$/;
  const reg2 = /^1[23456789]\d{9}$/;

  if (value && !reg1.test(value) && !reg2.test(value)) {
    callback(new Error('请输入正确的手机或座机号码'));
  } else {
    callback();
  }
}

// 校验图片验证码
export function validateImgCode(rule, value, callback) {
  const reg = /^[A-Za-z0-9]{4,6}$/;

  if (!value) {
    callback(new Error('图片验证不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('请正确输入图片验证，不限大小写'));
  } else {
    callback();
  }
}

// 校验短信验证码
export function validatePhoneCode(rule, value, callback) {
  const reg = /^[0-9]{4,6}$/;

  if (!value) {
    callback(new Error('短信验证码不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('请正确输入短信验证码'));
  } else {
    callback();
  }
}

// 校验住户姓名
export function validateHouseHoldName(rule, value, callback) {
  const reg = /^[A-Za-z\u4e00-\u9fa5]{1,10}$/gi;

  if (!value) {
    callback(new Error('住户名称不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('仅支持不超过10位的中文和字母'));
  } else {
    callback();
  }
}

// 校验管理员姓名
export function validatePersonName(rule, value, callback) {
  const reg = /^[A-Za-z\u4e00-\u9fa5]{1,10}$/gi;

  if (!value) {
    callback(new Error('姓名不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('仅支持不超过10位的中文和字母'));
  } else {
    callback();
  }
}

// 校验身份证
export function validateIdCard(rule, value, callback) {
  // const reg = /^[A-Za-z0-9]{18}$/;
  const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

  if (!value) {
    callback(new Error('身份证不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('请输入正确的18位身份证号'));
  } else {
    callback();
  }
}

// 详细地址
export function validateAddress(rule, value, callback) {
  const reg = /^[0-9a-zA-z\u4e00-\u9fa5]{1,30}$/;

  if (!value) {
    callback(new Error('详细地址不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('长度不超过30个字符，仅支持中文、数字及字母'));
  } else {
    callback();
  }
}

// 说明
export function validateRemarks(rule, value, callback) {
  const reg = /^[0-9a-zA-z\u4e00-\u9fa5]{0,20}$/;

  if (value && !reg.test(value)) {
    callback(new Error('长度不超过20个字符，仅支持中文、数字及字母'));
  } else {
    callback();
  }
}

// 联系人姓名
export function validateLinkman(rule, value, callback) {
  const reg = /^[A-Za-z\u4e00-\u9fa5]{1,10}$/gi;

  if (value && !reg.test(value)) {
    callback(new Error('仅支持不超过10位的中文和字母'));
  } else {
    callback();
  }
}

// 校验社区名称
export function validateZoneName(rule, value, callback) {
  const reg = /^[A-Za-z0-9\u4e00-\u9fa5]{1,15}$/gi;

  if (!value) {
    callback(new Error('社区名称不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('仅支持不超过15位的字符'));
  } else {
    callback();
  }
}
